// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3xlLL","selects":"Documents_selects__3OqvJ"};